export default {
	BurialPoint(params){
		return new Promise((resolve, reject) => {
			axios.post('/api/user/burial_point',params)
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
	activeApply(params){
		return new Promise((resolve, reject) => {
			axios.post('/api/huodong/recruit-enroll',params)
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
	activeApplyAll(params){
		return new Promise((resolve, reject) => {
			axios.post('/api/huodong/recruit-enroll-all',params)
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
	getActivity(params,id){
		return new Promise((resolve, reject) => {
			axios.get('/api/huodong/'+id+'/recruit-show',{
				params:params
			})
			.then((response) => {
				resolve(response)
			})
		}, err => {
			reject(err)
		})
	},
	uploadImg (params) {
        return new Promise((resolve, reject) => {
            axios.post('/api/upload',params,{
                headers:{'Content-Type':'multipart/form-data'}
            })
            .then((response) => {
                resolve(response)
            })
        }, err => {
            reject(err)
        })
    },
	
}